import { enrollmentApiRequest } from "./client";
import {
  useMutation,
  useQuery,
  useQueryClient
} from "react-query";
const _60_MINS = 1e3 * 60 * 60;
var EnrollmentStatus = /* @__PURE__ */ ((EnrollmentStatus2) => {
  EnrollmentStatus2["ACTIVE"] = "ACTIVE";
  EnrollmentStatus2["ARCHIVED"] = "ARCHIVED";
  EnrollmentStatus2["DISABLED"] = "DISABLED";
  EnrollmentStatus2["COMPLETED"] = "COMPLETED";
  return EnrollmentStatus2;
})(EnrollmentStatus || {});
const fetchEnrollments = (studentId, status) => {
  return enrollmentApiRequest({
    url: "/enrollment",
    method: "GET",
    params: { studentId, status }
  });
};
const fetchEnrollment = (enrollmentId) => {
  return enrollmentApiRequest({
    url: `/enrollment/${enrollmentId}`,
    method: "GET"
  });
};
const fetchAttemptLockDownBrowserSettings = (attemptId) => {
  return enrollmentApiRequest({
    url: `/lockdown-browser/attempt/${attemptId}`,
    method: "GET",
    headers: void 0
  });
};
function createTimeline(enrollment) {
  return enrollmentApiRequest({
    url: `/enrollment/${enrollment.enrollmentId}/timeline`,
    method: "POST"
  });
}
function useEnrollmentsQuery(studentId, enrollmentStatus = "ACTIVE" /* ACTIVE */) {
  const queryClient = useQueryClient();
  return useQuery(
    ["enrollments", studentId, enrollmentStatus],
    () => fetchEnrollments(studentId, enrollmentStatus),
    {
      useErrorBoundary: true,
      onSuccess(response) {
        var _a, _b;
        const enrollment = response.items[0];
        queryClient.setQueryData(
          ["enrollmentInitials"],
          ((_a = enrollment == null ? void 0 : enrollment.firstName) == null ? void 0 : _a[0]) + ((_b = enrollment == null ? void 0 : enrollment.lastName) == null ? void 0 : _b[0])
        );
      }
    }
  );
}
function useEnrollmentQuery(enrollmentId, enabled = true) {
  const queryClient = useQueryClient();
  return useQuery(
    ["enrollment", enrollmentId],
    () => fetchEnrollment(enrollmentId),
    {
      cacheTime: _60_MINS,
      staleTime: _60_MINS,
      enabled,
      onSuccess(enrollment) {
        var _a, _b;
        queryClient.setQueryData(
          ["enrollmentInitials"],
          ((_a = enrollment.firstName) == null ? void 0 : _a[0]) + ((_b = enrollment.lastName) == null ? void 0 : _b[0])
        );
      }
    }
  );
}
function useEnrollmentNameQuery() {
  const queryClient = useQueryClient();
  return useQuery(
    ["enrollmentInitials"],
    () => queryClient.getQueryData(["enrollmentInitials"]),
    { staleTime: Infinity, cacheTime: Infinity }
  );
}
function useEnrollmentCreateTimelineMutation() {
  return useMutation((enrollment) => createTimeline(enrollment), {
    useErrorBoundary: true
  });
}
function useAttemptLockDownBrowserSettingsQuery(attemptId, enabled) {
  return useQuery(
    ["proctoredAttempt", attemptId],
    () => fetchAttemptLockDownBrowserSettings(attemptId),
    {
      enabled
    }
  );
}
export {
  EnrollmentStatus,
  useAttemptLockDownBrowserSettingsQuery,
  useEnrollmentCreateTimelineMutation,
  useEnrollmentNameQuery,
  useEnrollmentQuery,
  useEnrollmentsQuery
};
